export const LOGIN_ENDPOINT = "/login";
export const USER_INFO = "/api/v1/auth/usuario";
export const MARCAR_PONTO = "/api/v1/ponto";
//Colaboradores
export const ALL_COLABORADORES = "/api/v1/colaborador";
export const INSERT_COLABORADORES = "/api/v1/colaborador";
export const ALL_COLABORADORES_BY_GESTOR = "/api/v1/colaborador/find-by-gestor";
export const ALL_COLABORADORES_BY_STATUS = "/api/v1/colaborador/status";
//Dia da Semana
export const ALL_DIAS_DA_SEMANA = "/api/v1/diadasemana";
//Expediente
export const ALL_EXPEDIENTE = "/api/v1/expediente";
export const INSERT_EXPEDIENTE = "/api/v1/expediente";
export const ALL_EXPEDIENTE_BY_GESTOR = "/api/v1/colaborador/find-by-gestor";
export const ALL_EXPEDIENTE_BY_STATUS = "/api/v1/expediente/status";
//Função
export const ALL_FUNCAO = "/api/v1/funcao";
export const INSERT_FUNCAO = "/api/v1/funcao";
export const ALL_FUNCAO_BY_SETOR_ATIVO = "/api/v1/funcao/setor-ativo";
export const ALL_FUNCAO_BY_SETOR = "/api/v1/funcao/setor";
export const ALL_FUNCAO_BY_STATUS = "/api/v1/funcao/status";
//Horario
export const ALL_HORARIOS = "/api/v1/horario";
export const INSERT_HORARIOS = "/api/v1/horario";
//Ponto
export const ALL_PONTO = "/api/v1/ponto";
export const INSERT_PONTO = "/api/v1/ponto";
export const ATUALIZAR_PONTO = "/api/v1/ponto";
export const ALL_PONTO_COLABORADOR = "/api/v1/ponto/colaborador";
export const ALL_PONTO_APROVAR_GESTOR = "/api/v1/ponto/to-approve-by-gestor";
export const APROVAR_PONTO = "/api/v1/ponto/approve";
export const REPROVAR_PONTO = "/api/v1/ponto/disapprove";
//Setor
export const ALL_SETOR = "/api/v1/setor";
export const INSERT_SETOR = "/api/v1/setor";
export const ALL_SETOR_BY_STATUS = "/api/v1/setor/status";
//Tipo de Registro
export const ALL_REGISTRO = "/api/v1/tipodoregistro";
//Status do ponto
export const STATUS_PONTO = "/api/v1/statusDoPonto";
//Password
export const CHANGE_PASSWORD = "/api/v1/auth/password";
export const RESET_USER_PASSWORD = "/api/v1/admin/users";
//Feriados
export const ALL_FERIADOS = "/api/v1/feriado";
